import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { filter, map, take } from 'rxjs/operators';
import { UserType } from '@shared/types/user-type';

export function roleGuard(allowedType: UserType): CanActivateFn {
  return (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    return authService.user$.pipe(
      filter((user) => user !== undefined),
      take(1),
      map((user) => {
        if (!user) {
          return router.createUrlTree(['/login']);
        }
        if (user.userType === allowedType) {
          return true;
        }
        // Redirect to the correct portal if they try to access the wrong one
        if (user.userType === UserType.BUSINESS) {
          return router.createUrlTree(['/my-business/dashboard']);
        } else {
          return router.createUrlTree(['/dashboard']);
        }
      }),
    );
  };
}
